import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Country } from '../../models/country';
import { GetCountries } from '../actions/countries';
import { CountriesState } from '../reducers/countries';
import {
  areCountriesLoaded,
  areCountriesLoading,
  getCountries,
  getSortedCountries,
} from '../selectors/countries';

@Injectable({ providedIn: 'root' })
export class CountriesFacade {
  public countries$: Observable<Country[]>;
  public sortedCountries$: Observable<Country[]>;
  public isLoading$: Observable<boolean>;
  public isLoaded$: Observable<boolean>;

  constructor(private _store: Store<CountriesState>) {
    this.countries$ = this._store.select(getCountries);
    this.sortedCountries$ = this._store.select(getSortedCountries);
    this.isLoading$ = this._store.select(areCountriesLoading);
    this.isLoaded$ = this._store.select(areCountriesLoaded);
  }

  public getCountries(isForce = false): void {
    this._store.dispatch(GetCountries(isForce));
  }
}
